<template>
  <Modal :open="isOpen" @close="closeSellerModal" size="medium" :show-close-button="true">
    <div class="text-center mb-6">
      <h2 class="text-2xl font-bold text-gray-900">Ajouter un vendeur</h2>
    </div>
    <VeeForm v-slot="{ handleSubmit }" :validation-schema="schema" as="div">
      <form class="space-y-4" @submit="handleSubmit($event, handleSellerCreation)" ref="saleCreationForm">
        <div class="grid grid-cols-2 gap-x-4 gap-y-3">
          <div class="flex-1">
            <label for="firstName" class="block text-sm text-gray-700">
              Prénom
              <span class="ml-1 text-red-600">*</span>
            </label>
            <Field
              type="text"
              name="seller.firstName"
              id="firstName"
              autocomplete="given-name"
              class="shadow-xs focus:ring-primary focus:border-primary block w-full sm:text-sm border-gray-300 rounded-md"
              placeholder="John"
              v-model="seller.firstName"
            />
            <ErrorMessage name="seller.firstName" class="mt-2 text-sm text-red-600" />
          </div>
          <div class="flex-1">
            <label for="lastName" class="block text-sm text-gray-700">
              Nom
              <span class="ml-1 text-red-600">*</span>
            </label>
            <Field
              type="text"
              name="seller.lastName"
              id="lastName"
              autocomplete="family-name"
              class="shadow-xs focus:ring-primary focus:border-primary block w-full sm:text-sm border-gray-300 rounded-md"
              placeholder="Doe"
              v-model="seller.lastName"
            />
            <ErrorMessage name="seller.lastName" class="mt-2 text-sm text-red-600" />
          </div>
        </div>
        <div class="flex justify-center">
          <div>
            <GenericButton type="submit">Confirmer</GenericButton>
          </div>
        </div>
      </form>
    </VeeForm>
  </Modal>
</template>

<script>
import { Form as VeeForm, Field, ErrorMessage } from "vee-validate";
import { Modal, GenericButton } from "@estaly/ui";
import * as yup from "yup";
import { mapActions, mapState } from "vuex";

export default {
  components: {
    VeeForm,
    Field,
    ErrorMessage,
    GenericButton,
    Modal,
  },

  props: {
    isOpen: Boolean,
  },

  emits: ["getSellers", "closeSellerCreation"],

  computed: {
    ...mapState("store", ["selectedStoreId"]),
  },

  data: () => {
    const schema = yup.object({
      seller: yup.object({
        firstName: yup.string().required("Le prénom du vendeur est requis."),
        lastName: yup.string().required("Le nom du vendeur est requis."),
      }),
    });

    return {
      schema,
      seller: {
        firstName: "",
        lastName: "",
      },
    };
  },

  methods: {
    ...mapActions("notifications", ["notify"]),
    ...mapActions("sellers", ["create"]),

    closeSellerModal() {
      this.$emit("closeSellerCreation");
    },

    resetAttributes() {
      this.seller = {
        firstName: "",
        lastName: "",
      };
    },

    async handleSellerCreation() {
      const storeId = this.selectedStoreId;
      const sellerData = {
        seller: {
          first_name: this.seller.firstName,
          last_name: this.seller.lastName,
        },
      };
      const response = await this.create({ storeId, data: sellerData });
      if (response?.success) {
        this.$emit("getSellers");
        this.closeSellerModal();
        this.notify({
          category: "simple",
          type: "success",
          title: "Le vendeur a été ajouté avec succès.",
        });
        setTimeout(() => {
          this.resetAttributes();
        }, 500);
      } else if (response?.status === 409) {
        this.notify({
          type: "error",
          category: "simple",
          title: "Le vendeur existe déjà.",
          text: "Veuillez le sélectionner.",
        });
        this.closeSellerModal();
      }
    },
  },
};
</script>
